<template>
  <div class="loading-overlay" :class="{'hidden':!show}" @touchmove.prevent>
    <!-- ============== 小点开始 ============== -->
    <div class="a-dot-box" v-if="isShowDot">
      <div class="a-dot-round"></div>
      <div class="a-dot-round" style="animation-delay: 0.1s;"></div>
      <div class="a-dot-round" style="animation-delay: 0.3s;"></div>
    </div>
    <!-- ============== 菊花开始 ============== -->
    <div class="a-spinner-box" v-if="isShowDefault">
      <div class="a-spinner-wrapper">
        <div class="a-spinner a-spinner-L a-spinner-light">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div v-if="title" class="loading-title">{{ title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      type: {
        type: String
      }
    },
    computed: {
      isShowDot () {
        if (this.type === 'dot') {
          return true
        }
        return false
      },
      isShowDefault () {
        if (!this.type || this.type === '') {
          return true
        }
        return false
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "../../../scss/vars";

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    z-index: 1000;
    &.hidden {
      opacity: 0;
    }
  }

  .a-dot-box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    .a-dot-round {
      display: inline-block;
      vertical-align: middle;
      margin-left: 6px;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      background: #4889db;
      opacity: 0.1;
      animation: a-dot-animation 0.9s linear infinite;
      &::first-child { margin-left: 0}
    }
  }

  @keyframes a-dot-animation {
    0% { opacity: 0.1;}
    50% { opacity: 1;}
    100% { opacity: 0.1;}
  }

  .a-spinner-box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0) scale(0.8);
    background-color: rgba(0,0,0,0.75);
    border-radius: 6px;
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
  .a-spinner-wrapper {
    transform: scale(0.8);
  }

  .loading-title {
    margin-top: 8px;
    font-size: 12px;
    color: #ddd;
    width: 80%;
    // white-space: nowrap;
    // overflow: hidden;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/ui/base/components/loading.vue